import { FEATURES } from '@constants/Text'
import { isCliente } from '@modules/financial-planning/utils/client-permissions'

/**
 * Regra de autorização da Base de Ativos, em UM lugar.
 *
 * Antes desta extração a mesma condição existia em cinco arquivos com cinco grafias
 * (`settings/routes.js`, `constants/navigation-routes.js`, a home do módulo, o wrapper do
 * módulo e `mercado.vue`). Duas eram byte a byte iguais; as outras divergiam em detalhes
 * inócuos naquele momento. Mudar a regra exigia acertar os cinco pontos.
 *
 * ★ Toda função aqui lê a FLAG antes de olhar o papel do usuário, de propósito. Com o papel
 * num early return, o Vue 2 não registra `$access` como dependência do computed que chama
 * (a leitura fica inalcançável naquele caminho) e o valor congela no primeiro render — a
 * flag pode chegar depois do mount e a tela não reage.
 *
 * ★ Toda função aqui reprova o CLIENTE FINAL explicitamente. A regra original só somava
 * capacidade (`IS_GESTOR || flag`) e nunca subtraía perfil: uma sessão `IS_CLIENTE` num
 * escritório com as duas flags satisfazia a condição, e as rotas não têm `meta.permission`
 * — o guard global cai no `else { next() }` e a tela de Configurações renderiza para o
 * perfil errado. Precedente do gate de perfil: `financial-planning/utils/client-permissions`.
 *
 * @param {object} user usuário da sessão (`$currentUser()` / `ctx.user` / `ctx.currentUser`)
 * @param {object} show mapa de features do escritório (`$access` / `ctx.show` / `ctx.access`)
 */
export const podeGerenciarBaseAtivos = (user, show) => {
  const temFlag = Boolean((show || {})[FEATURES.BASE_ATIVOS_CONSULTOR])
  if (!user) return false
  if (isCliente(user)) return false
  return temFlag || Boolean(user.IS_GESTOR)
}

/**
 * Acesso ao MÓDULO Asset Allocation. `ASSET_LOCATION` segue obrigatório para todos: a flag
 * do consultor ELEVA permissão dentro do módulo, não substitui o acesso a ele.
 */
export const podeAcessarBaseAtivos = (user, show) => {
  const temAssetLocation = Boolean((show || {})[FEATURES.ASSET_LOCATION])
  const podeGerenciar = podeGerenciarBaseAtivos(user, show)
  return temAssetLocation && podeGerenciar
}

/**
 * O consultor que entrou PELA FLAG — quem vê o módulo reduzido à Base de Ativos. Gestor é
 * `false` aqui de propósito: ele usa o caminho completo das Configurações.
 */
export const isConsultorBaseAtivos = (user, show) => {
  const acesso = show || {}
  const temFlag = Boolean(acesso[FEATURES.BASE_ATIVOS_CONSULTOR])
  const temAssetLocation = Boolean(acesso[FEATURES.ASSET_LOCATION])
  if (!user) return false
  if (isCliente(user)) return false
  return temFlag && temAssetLocation && !user.IS_GESTOR
}
